/* eslint-disable react/prop-types */
import React from 'react'
import LabelTemplate, { reasons, unkownReason } from 'src/components/LabelTemplate'

export default function ReasonTemplate ({ reason = 'unkown' }) {
  const foundReason = reasons.find(r => r.value === reason) || unkownReason

  return <LabelTemplate text={foundReason.label} color={foundReason.color} />
}
